import { createSharedStockSlice, sharedStockInitialState } from '@/shared/modules/stock/business';
const initialState = {
    ...sharedStockInitialState,
    searchTerm: '',
};
const stockSlice = createSharedStockSlice({
    name: 'stocks',
    initialState: initialState,
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
    },
});
export const { actions: stocksActions, reducer: stockStateReducer } = stockSlice;
